import React from 'react';
import { withRouter } from 'react-router';
import R from 'ramda';
import '../statics/stylesheet.css';

/**
 * caller:
 * Options.js
 *
 * http://localhost:8080/#/Tires/Vehicle
 */
class VehicleSelection extends React.Component {
  constructor(props) {
    if (JSON.parse(localStorage.getItem('feedForFilter'))) {
      localStorage.removeItem('feedForFilter');
    }
    if (window.localStorage.getItem('winter wheels')) {
      window.localStorage.removeItem('winter wheels');
    }

    super(props);
    this.state = {
      loading: false,
      checked: false,
      year: window.localStorage.getItem('carYear') === null ? undefined : window.localStorage.getItem('carYear'),
      make: window.localStorage.getItem('carMake') === null ? undefined : window.localStorage.getItem('carMake'),
      model: window.localStorage.getItem('carModel') === null ? undefined : window.localStorage.getItem('carModel')
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillMount() {
    window.sessionStorage.removeItem('wheelSize');
    window.sessionStorage.removeItem('staggered');

    this.fillDropDowns(this.state.year, this.state.make);
  }

  getOptionsListFor(optionType) {
    const getOptions = (option) => <option key={option} value={option}>{option}</option>;
    return R.map(getOptions)(this.state[optionType]);
  }

  onChangeDropdownSelected(event, type) {
    const value = event.target.value;
    const year = type === 'year' ? value : this.state.year;
    const make = type === 'make' ? value : type === 'model' ? this.state.make : undefined;
    const model = type === 'model' ? value : undefined;

    this.setState({ year, make, model });

    if (!this.props.confirm) {
      this.props.cbVehicleSelection({ value });
    }

    year !== undefined ? window.localStorage.setItem('carYear', year) : window.localStorage.removeItem('carYear');
    make !== undefined ? window.localStorage.setItem('carMake', make) : window.localStorage.removeItem('carMake');
    model !== undefined ? window.localStorage.setItem('carModel', model) : window.localStorage.removeItem('carModel');

    this.fillDropDowns(year, make);
  }

  fillDropDowns(year, make) {
    const data = JSON.parse(localStorage.getItem('vehicles'));
    // delete data.expireTime;

    if (!data[year]) {
      year = Object.keys(data)[0];
    }
    if (!data[year][make]) {
      make = Object.keys(data[year])[0];
    }
    const sortedMakes = year !== undefined ? Object.keys(data[year]).sort() : undefined;
    const sortedModels = year !== undefined && make !== undefined ? data[year][make].sort() : undefined;

    this.setState({
      years: Object.keys(data).reverse(),
      makes: sortedMakes,
      models: sortedModels
    });
  }

    /**
     * private utility
     *
     * caller:
     * getYears
     * getMakes
     * getModels
     *
     * usecase:
     * do the actual fetch
     *
     *
     * @param {string} url, the full path used to fetch
     * @param {string} title, TASK: not used anymore, this is hard coded into each <select> list
     * @param {string} vehicleParamKey years, makes, models
     *
     */

  onClickGetVehicleResults() {
    const { category, search_by } = this.props.params;
    const { year, make, model } = this.state;
    const wintertest2 = window.localStorage.getItem('category');

    if ( wintertest2 === 'Winter Packages') {
      window.localStorage.setItem('winter wheels', 'false');
    }

    if (year !== undefined || make !== undefined || model !== undefined) {
      window.localStorage.setItem('carYear', year);
      window.localStorage.setItem('carMake', make);
      window.localStorage.setItem('carModel', model);
    }
    const modifiedMake = make.split(' ').join('%20');
    const modifiedModel = model.split(' ').join('%20');
    const modifiedModelSlash = modifiedModel.split('/').join('%2F');

    fetch('https://www.soratwheels.ca/apii/tires.php/search/tires/vehicle/year/' + this.state.year + '/make/' + this.state.make + '/model/' + this.state.model)
    .then(response => {
      return response.json();
    }).then(json => {
      localStorage.setItem('Offset_range', Object.values(json.Offset_range));
      localStorage.setItem('Lugnut_Type', Object.values(json.Lugnut_Type));
      localStorage.setItem('Lugnut_Size', Object.values(json.Lugnut_Size));
      localStorage.setItem('Center_bore', Object.values(json.Center_bore));
      localStorage.setItem('bolt_pattern', Object.values(json.bolt_pattern));
    });

    this.context.router.push('/' + category.replace(/ /g, '%20') + '/' + search_by + '/' + year + '!' + modifiedMake + '!' + modifiedModelSlash);
  }

  filledInformation() {
    if (this.state.year === undefined || this.state.make === undefined || this.state.model === undefined) {
      return true;
    }
    return false;
  }

  returnVehicleInformation = () => {
    window.localStorage.setItem('carYear', this.state.year);
    window.localStorage.setItem('carMake', this.state.make);
    window.localStorage.setItem('carModel', this.state.model);
    this.props.whenClicked();
  }

  TabPanel = (props) => {
    const { children, value, index } = props;

    return (
			<div
				role="tabpanel"
				id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
	>
				{value === index && <div>{children}</div>}
			</div>
    );
  };

  a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
      style: { background: 'white', Width: '33%' }
    };
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  handleCheck = (event) => {
    const wheelschch = this.state.checked;

    if ( wheelschch === false) {
      this.setState({ checked: true });
    } else {
      this.setState({ checked: false });
    }
    localStorage.setItem('winter wheels', this.state.checked);
  };

  render() {
    const { loading, year, make, model } = this.state;
    const category = this.props.params ? this.props.params.category : undefined;
    const search_by = this.props.params ? this.props.params.search_by : undefined;
    const yearValue = year === undefined ? 'Year' : window.localStorage.getItem('carYear');
    const makeValue = make === undefined ? 'Make' : window.localStorage.getItem('carMake');
    const modelValue = model === undefined ? 'Model' : window.localStorage.getItem('carModel');

    const wintertest = window.localStorage.getItem('category');

    return (
            <div className="content-divLength">

                <div className="vehicleSelection-contentTires full-width">
                    {(this.props.confirm ?
                        <h2 className="content-titleFont">Select or Confirm vehicle</h2> :
                        <h2 className="content-titleFont">SELECT <strong style={{ color: '#C50000' }}>{category.toUpperCase()}</strong> BY VEHICLE:</h2>)}

                    <div className="vehicleSelection-selectVehicle__btnListContainer">
                        <select 
                            value={this.state.year || 'Year'}
                            className="vehicleSelection-selectVehicle__select vehicleSelection_year"
                            onChange={(event) => this.onChangeDropdownSelected(event, 'year')}
                            style={{
                                padding: '12px 16px',
                                borderRadius: '3px',
                                border: '1px solid #770303ff',
                                fontSize: '14px',
                                background: 'rgba(0, 0, 0, 0.7)',
                                color: '#ffffff',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                marginRight: '10px',
                                backdropFilter: 'blur(10px)'
                            }}
                        >
                            <option value="Year" disabled style={{color: '#000', background: '#fff'}}>Select Year</option>
                            {this.state.years && this.getOptionsListFor('years')}
                        </select>

                        <select 
                            value={this.state.make || 'Make'}
                            className="vehicleSelection-selectVehicle__select vehicleSelection_make"
                            onChange={(event) => this.onChangeDropdownSelected(event, 'make')}
                            disabled={!this.state.year || this.state.year === 'Year'}
                            style={{
                                padding: '12px 16px',
                                borderRadius: '3px',
                                border: (!this.state.year || this.state.year === 'Year') ? '2px solid #666666' : '1px solid #770303ff',
                                fontSize: '14px',
                                background: (!this.state.year || this.state.year === 'Year') ? 'rgba(100, 100, 100, 0.3)' : 'rgba(0, 0, 0, 0.7)',
                                color: (!this.state.year || this.state.year === 'Year') ? '#999999' : '#ffffff',
                                cursor: (!this.state.year || this.state.year === 'Year') ? 'not-allowed' : 'pointer',
                                opacity: (!this.state.year || this.state.year === 'Year') ? 0.5 : 1,
                                transition: 'all 0.3s ease',
                                marginRight: '10px',
                                backdropFilter: (!this.state.year || this.state.year === 'Year') ? 'none' : 'blur(10px)'
                            }}
                        >
                            <option value="Make" disabled style={{color: '#000', background: '#fff'}}>Select Make</option>
                            {this.state.makes && this.getOptionsListFor('makes')}
                        </select>

                        <select 
                            value={this.state.model || 'Model'}
                            className="vehicleSelection-selectVehicle__select vehicleSelection_model"
                            onChange={(event) => this.onChangeDropdownSelected(event, 'model')}
                            disabled={!this.state.make || this.state.make === 'Make'}
                            style={{
                                padding: '12px 16px',
                                borderRadius: '3px',
                                border: (!this.state.make || this.state.make === 'Make') ? '2px solid #666666' : '1px solid #770303ff',
                                fontSize: '14px',
                                background: (!this.state.make || this.state.make === 'Make') ? 'rgba(100, 100, 100, 0.3)' : 'rgba(0, 0, 0, 0.7)',
                                color: (!this.state.make || this.state.make === 'Make') ? '#999999' : '#ffffff',
                                cursor: (!this.state.make || this.state.make === 'Make') ? 'not-allowed' : 'pointer',
                                opacity: (!this.state.make || this.state.make === 'Make') ? 0.5 : 1,
                                transition: 'all 0.3s ease',
                                marginRight: '10px',
                                backdropFilter: (!this.state.make || this.state.make === 'Make') ? 'none' : 'blur(10px)'
                            }}
                        >
                            <option value="Model" disabled style={{color: '#000', background: '#fff'}}>Select Model</option>
                            {this.state.models && this.getOptionsListFor('models')}
                        </select>

                        {this.props.confirm ?
                            <button 
                                className="vehicleSelection-contentTires__btnlist"
                                disabled={this.filledInformation()}
                                onClick={() => this.returnVehicleInformation()}
                                style={{
                                    background: this.filledInformation() ? 'rgba(92, 73, 73, 0.5)' : 'linear-gradient(135deg, #C50000 0%, #a00000 100%)',
                                    color: 'white',
                                    border: 'none',
                                    padding: '9px 24px',
                                    borderRadius: '3px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    cursor: this.filledInformation() ? 'not-allowed' : 'pointer',
                                    opacity: this.filledInformation() ? 0.5 : 1,
                                    transition: 'all 0.3s ease',
                                    boxShadow: this.filledInformation() ? 'none' : '0 4px 12px rgba(197, 0, 0, 0.3)'
                                }}
                            >
                                Confirm
                            </button> :
                            <button 
                                className="vehicleSelection-contentTires__btnlist"
                                disabled={this.filledInformation()}
                                onClick={this.onClickGetVehicleResults.bind(this)}
                                style={{
                                    background: this.filledInformation() ? 'rgba(90, 70, 70, 1)' : 'linear-gradient(135deg, #C50000 0%, #a00000 100%)',
                                    color: 'white',
                                    border: 'none',
                                    padding: '9px 16px',
                                    borderRadius: '3px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    cursor: this.filledInformation() ? 'not-allowed' : 'pointer',
                                    opacity: this.filledInformation() ? 0.5 : 1,
                                    transition: 'all 0.3s ease',
                                    boxShadow: this.filledInformation() ? 'none' : '0 4px 12px rgba(197, 0, 0, 0.3)'
                                }}
                            >
                                Select
                            </button>
                        }
                    </div>
                    {this.props.params.category === 'Wheels' && wintertest !== 'Winter Packages' &&
                        <div style={{ 
                          width: '100%', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          gap: '8px',
                          padding: '10px'
                        }}>
                          <input 
                            style={{ 
                              width: '20px', 
                              height: '20px',
                              cursor: 'pointer',
                              accentColor: '#C50000',
                              margin: '0',
                              verticalAlign: 'middle'
                            }} 
                            className="content-titleFont" 
                            type="checkbox" 
                            id="wintercheckbox" 
                            onChange={this.handleCheck} 
                            defaultChecked={this.state.checked}
                          />
                          <label 
                            style={{ 
                              color: 'white', 
                              fontSize: '14px',
                              cursor: 'pointer',
                              userSelect: 'none',
                              margin: '0',
                              lineHeight: '20px',
                              display: 'flex',
                              alignItems: 'center'
                            }} 
                            htmlFor="wintercheckbox"
                          >
                            Winter Approved
                          </label>
                        </div>
                    }
                    {wintertest === 'Winter Packages' &&
                        <div style={{ 
                          width: '100%', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          gap: '8px',
                          padding: '10px'
                        }}>
                          <label 
                            style={{ 
                              color: 'white', 
                              fontSize: '14px',
                              cursor: 'pointer',
                              userSelect: 'none',
                              marginLeft: '0'
                            }} 
                            htmlFor="wintercheckbox"
                          >
                            Winter Approved
                          </label>
                        </div>
                    }
                    {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
                        loading &&
                        < div style={{ textAlign: 'center', margin: 'auto' }}>
                            <img src={window.host + '/statics/img/loading.svg'}
                                 style={{ width: '35px', height: '35px' }}/>
                        </div> :
                        loading &&
                        < div style={{ textAlign: 'center', margin: 'auto' }}>
                            <img src={window.host + '/statics/img/loading.gif'}
                                 style={{ width: '35px', height: '35px' }}/>
                        </div>
                    }

                </div>
            </div>
    );
  }
}

VehicleSelection.propTypes = {
  cbVehicleSelection: React.PropTypes.func,
  confirm: React.PropTypes.bool.isRequired,
  params: React.PropTypes.object.isRequired
};

VehicleSelection.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default withRouter(VehicleSelection);
//





// WEBPACK FOOTER //
// ./src/components/VehicleSelection.js